import { Box, Flex, Text, Button, VStack, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import ActivityIcon from "@root/assets/icons/activityIcon.svg";
import NotificationIcon from "@root/assets/icons/notificationIcon.svg";
import { ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";
import { useNoticeContext } from "@root/context/notice-context";
import { useEffect } from "react";
import { getTimeAgo } from "@root/utils/date-helper";

const cardBg = "white";
const cardBorder = "1px solid #E4EBF0";
const cardRadius = "16px";

const activityIcon = () => {
  return <Image src={ActivityIcon} />;
};

const notificationIcon = () => {
  return <Image src={NotificationIcon} />;
};

export const RecentActivities = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { publishNoticeData, fetchPublishNotice } = useNoticeContext();
  useEffect(() => {
    fetchPublishNotice();
  }, []);

  const noRecentActivity = () => {
    if (!publishNoticeData?.length)
      return (
        <Flex
          flexDir={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          // height={"70%"}
        >
          {notificationIcon()}
          <Text fontWeight={600} fontSize={"18px"} mt={3}>
            {t("recentActivities.noRecentActivity")}
          </Text>
        </Flex>
      );
  };
  return (
    <Box
      flex="1"
      bg={cardBg}
      border={cardBorder}
      borderRadius={cardRadius}
      minW="320px"
      style={{ border: "1px solid #CDD6DC" }}
      data-tour-item="pledge-dashboard-recent-activities"
    >
      <Flex
        justify="space-between"
        align="center"
        mb={4}
        p={4}
        bg={"#F9F8FF"}
        borderTopRadius={cardRadius}
      >
        <Text fontWeight="bold" fontSize={"18px"}>
          {t("recentActivities.title")}
        </Text>
        <Button
          variant="link"
          color="gray"
          fontSize={"14px"}
          fontWeight="500"
          size="sm"
          onClick={() => navigate(ROUTE_NAMES.PLEDGE_ALL_NOTICES)}
        >
          {t("recentActivities.seeMore")}
        </Button>
      </Flex>
      <VStack align="stretch" spacing={3} p={4}>
        {publishNoticeData?.slice(0, 5)?.map((item: any) => (
          <Flex key={item?.id} align="center" justify="space-between" cursor='pointer' onClick={() => navigate(ROUTE_NAMES.PLEDGE_ALL_NOTICES)}>
            <Flex align="center" gap={2}>
              <Box bg={"#191BDF1A"} borderRadius={"50%"} p={2}>
                {activityIcon()}
              </Box>
              <Box marginLeft={2}>
                <Text fontWeight="500">{item?.title}</Text>
              </Box>
            </Flex>
            <Flex
              direction="column"
              align="flex-end"
              fontSize="sm"
              color="gray.500"
            >
              <Text>{getTimeAgo(item?.createdAt)}</Text>
            </Flex>
          </Flex>
        ))}
      </VStack>
      {/* No recent activity */}
      {noRecentActivity()}
    </Box>
  );
};
